import { storageKeyLng, SupportedLanguages } from 'constants/language'
import useOutsideClick from 'hooks/useOutsideClick'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './style.scss'

export default function MultiLanguage() {
  const [visible, setVisible] = useState(false)
  const ref = useRef(null)

  const {
    i18n: { changeLanguage, language },
  } = useTranslation()

  function findLng(key: string) {
    return SupportedLanguages.find((obj) => obj.key === key)
  }

  function filterLng(key: string) {
    const data = JSON.parse(
      JSON.stringify(SupportedLanguages)
    ) as typeof SupportedLanguages

    const index = data.findIndex((obj) => obj.key === key)

    if (index > -1) data.splice(index, 1)

    return data
  }

  function loadLng(key?: string) {
    if (typeof key === 'undefined') {
      const storageI18nLng = localStorage.getItem(storageKeyLng)
      if (storageI18nLng) changeLanguage(storageI18nLng)
    } else if (typeof key === 'string') {
      localStorage.setItem(storageKeyLng, key)
    }
  }

  useOutsideClick(ref, () => {
    if (visible) setVisible(false)
  })

  useEffect(() => {
    loadLng()
  }, [])

  useEffect(() => {
    loadLng(language)
  }, [language])

  return (
    <div className={`multi-lng ${visible ? 'active' : ''}`} ref={ref}>
      <div
        className='multi-lng__item-preview'
        title={findLng(language)?.key || ''}
        onClick={() => setVisible(true)}
      >
        <img
          src={findLng(language)?.icon}
          draggable='false'
          loading='lazy'
          alt=''
        />
      </div>

      <div className='multi-lng__g-item'>
        <div className='multi-lng__item'>
          <img
            src={findLng(language)?.icon}
            draggable='false'
            loading='lazy'
            alt=''
          />
        </div>

        {filterLng(language).map((obj, i) => {
          return (
            <div
              className='multi-lng__item'
              key={i}
              onClick={() => {
                changeLanguage(obj.key)
                setVisible(false)
              }}
            >
              <img src={obj.icon} draggable='false' loading='lazy' alt='' />
            </div>
          )
        })}
      </div>
    </div>
  )
}
